import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import semanticColorVariant from '../../internal/styles/semanticColorVariant';

const Message = styled('span', {
  shouldForwardProp,
})(
  css({
    fontSize: 'body.0',
    fontWeight: 'medium',
    fontFamily: 'body',
  }),
  semanticColorVariant((color) => ({ color }))
);

Message.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Message;
